var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("ContinuousReportSummary.Menu.Results")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.results
      ? _c(
          "div",
          [
            !_vm.showTargetSummaries && !_vm.showOperationTotals
              ? [
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "ContinuousReportSummary.Results.TargetSummary.NoTargets"
                          )
                        )
                      )
                    ])
                  ])
                ]
              : [
                  _c(
                    "div",
                    {
                      staticClass: "accordion",
                      attrs: {
                        role: "tablist",
                        "aria-multiselectable": "true",
                        "aria-label": _vm.$t(
                          "ContinuousReportSummary.Results.TargetSummary.TargetTitle"
                        )
                      }
                    },
                    [
                      _vm.showTargetSummaries
                        ? _vm._l(_vm.targetSummaries, function(
                            targetSummary,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: targetSummary.target.name,
                                staticClass: "group-wrapper mb-3"
                              },
                              [
                                _c("div", { staticClass: "heading-div row" }, [
                                  _c(
                                    "button",
                                    {
                                      class: "tab-button btn col",
                                      attrs: {
                                        type: "button",
                                        id: "target-" + index,
                                        role: "tab",
                                        "data-toggle": "collapse",
                                        "data-target": "#collapse" + index,
                                        "aria-controls": "collapse" + index,
                                        "aria-expanded": true
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-plus fa-lg"
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fas fa-minus fa-lg"
                                      }),
                                      _vm._v(" "),
                                      _c("header-control", {
                                        attrs: {
                                          title: _vm.$t(
                                            "ContinuousReportSummary.Results.TargetSummary.TargetWithIndex",
                                            null,
                                            [index + 1]
                                          ),
                                          id: "targetheading-" + index,
                                          doNotUseResources: true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse show",
                                    attrs: { id: "collapse" + index }
                                  },
                                  [
                                    _c("target-summary-control", {
                                      attrs: {
                                        index: index,
                                        targetSummary: targetSummary,
                                        notes: _vm.notes
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showOperationTotals
                        ? [
                            _c("operation-summary-tables-control", {
                              staticClass: "mb-2 mt-5",
                              attrs: {
                                title:
                                  "ContinuousReportSummary.Results.ComputedOperationTotals",
                                showTargetGroups: false,
                                operations: _vm.results.computedOperationTotals
                              }
                            }),
                            _vm._v(" "),
                            _c("radio-button-row", {
                              key: _vm.radioButtonKey,
                              attrs: {
                                title:
                                  "ContinuousReportSummary.Results.OperationTotalsCorrect",
                                required: true
                              },
                              model: {
                                value: _vm.operationTotalsCorrect,
                                callback: function($$v) {
                                  _vm.operationTotalsCorrect = $$v
                                },
                                expression: "operationTotalsCorrect"
                              }
                            }),
                            _vm._v(" "),
                            _vm.operationTotalsCorrect === false
                              ? _c("operation-summary-tables-control", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    title:
                                      "ContinuousReportSummary.Results.RevisedOperationTotals",
                                    isRevisionTable: true,
                                    operations:
                                      _vm.results.revisedOperationTotals
                                  }
                                })
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }